export function convertMinutesToHours (minutes) {
    if (typeof minutes !== "number" || minutes < 0) return ""  ;

    const hours = Math.floor(minutes / 60) ;
    const remainingMinutes =  minutes % 60 ;

    let result = "";

    if (hours > 0 ) {

        result += `${hours} hour${hours > 1 ? 's' : ''}` ;

    }

    if (remainingMinutes > 0 ) {
        if (hours > 0 ) result += " & " ;
        result += `${remainingMinutes} minute${minutes > 1 ? 's' : ''}` ;

    }

    return result ;
    
}


export function parseTimeString(timeStr) {
  // Remove extra spaces at start & end
  const cleaned = timeStr.trim();

  // Split into words
  const parts = cleaned.split(/\s+/);

  let hour = 0;
  let minute = 0;

  for (let i = 0; i < parts.length; i++) {
    if (parts[i] === "hour" || parts[i] === "hours") {
      hour = Number(parts[i - 1]);
    }

    if (parts[i] === "minute" || parts[i] === "minutes") {
      minute = Number(parts[i - 1]);
    }
  }

  return { hour, minute };
}
